import * as actionType from './type';

const INITIAL_STATE = {
    isLoading : false,
    error : "",
    template : [],
    specificTemplate : {},
    templateList : [],
    webToLeadData : {}
}

export default function (state = INITIAL_STATE,action){
    switch(action.type) {
        case(actionType?.REQUEST_GET_TEMPLATE):{
            return{
                ...state,
                isLoading:true
            }
        }
        case(actionType?.RECEIVED_WEB_TO_LEAD_DATA):{
            return {
                ...state,
                isLoading : false,
                webToLeadData : action?.payload
            }
        }
        case(actionType?.RECEIVED_TEMPLATE):{
            return{
                ...state,
                isLoading:false,
                template : action?.payload
            }
        }
        case(actionType?.REQUEST_GET_SPECIFIC_TEMPLATE):{
            return{
                ...state,
                isLoading:true
            }
        }
        case(actionType?.RECEIVED_SPECIFIC_TEMPLATE):{
            return{
                ...state,
                isLoading:false,
                specificTemplate : action?.payload
            }
        }
        case(actionType?.RECEIVED_ERROR):{
        return{
            ...state,
            isLoading:false,
            error : action?.payload
        }
    }
     case(actionType?.EMPTY_SPECIFIC_TEMPLATE):{
        return{
            ...state,
            isLoading:false,
            specificTemplate : action?.payload
        }
    }
    
    case(actionType?.REQUEST_GET_TEMPLATE_LIST):{
        return{
            ...state,
            isLoading:true
        }
    }
    case(actionType?.RECEIVED_TEMPLATE_LIST):{
        return{
            ...state,
            isLoading:false,
            templateList : action?.payload
        }
    }
    
    case(actionType?.RECEIVED_TEMPLATE_LIST):{
        return{
            ...state,
            isLoading:false,
            templateList : []
        }
    }
    default:
        return state;
    }
}